import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-foreground-950 text-foreground-300">
      <div className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <h3 className="text-white font-semibold text-lg mb-3">CSSBuy Spreadsheet</h3>
            <p className="text-sm leading-relaxed text-foreground-400 mb-4">
              {t('footer.desc')}
            </p>
            <p className="text-xs text-foreground-500">
              {t('footer.independent')}
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">{t('footer.links')}</h4>
            <ul className="space-y-2">
              <li><Link to="/cssbuy-spreadsheet/" className="text-sm text-foreground-400 hover:text-white transition-colors">{t('nav.spreadsheet')}</Link></li>
              <li><Link to="/about/" className="text-sm text-foreground-400 hover:text-white transition-colors">{t('footer.about')}</Link></li>
              <li><Link to="/contact/" className="text-sm text-foreground-400 hover:text-white transition-colors">{t('footer.contact')}</Link></li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">{t('footer.categories')}</h4>
            <ul className="space-y-2">
              {['cat.shoes', 'cat.hoodies', 'cat.tshirts', 'cat.jackets', 'cat.bags', 'cat.accessories'].map((k) => (
                <li key={k}>
                  <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-white transition-colors">
                    {t(k)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">{t('footer.legal')}</h4>
            <ul className="space-y-2">
              <li><Link to="/privacy/" className="text-sm text-foreground-400 hover:text-white transition-colors">{t('footer.privacy')}</Link></li>
              <li><Link to="/disclaimer/" className="text-sm text-foreground-400 hover:text-white transition-colors">{t('footer.disclaimer')}</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-6 text-center">
          <p className="text-xs text-foreground-500">{t('footer.copyright')}</p>
        </div>
      </div>
    </footer>
  );
}